import socket from './socket';

/* Actions */

const getDashboard = (headers) => socket.get('/analogs/dashboard', undefined, headers);

const getDashboardData = (headers) =>
  socket.get('/settings/show-dashboard-component', undefined, headers);

const createComponent = (type, data, headers) =>
  socket.post(`/settings/dashboard-component${type}`, data, headers);

const updateComponent = (type, id, data, headers) =>
  socket.patch(`/settings/dashboard-component${type}/${id}`, data, headers);

const deleteComponent = (id, headers) => socket.delete(`/settings/${id}`, undefined, headers);

export default {
  getDashboard,
  getDashboardData,
  createComponent,
  updateComponent,
  deleteComponent,
};
